export default __webpack_public_path__ + "static/code-dd33a22774a276f881474ee5b1886f25.png";